exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".help-block {\n  color: #ff4081; }\n\n.nextLk {\n  width: 90%;\n  left: 5%;\n  margin-bottom: 10px; }\n\n.form-group {\n  margin-bottom: 0px; }\n\n@media screen and (min-width: 424px) {\n  .mat-card-header {\n    font-size: 18px; }\n  .registration-card {\n    width: 65%; } }\n\n@media screen and (max-width: 424px) {\n  .mat-card-header {\n    font-size: 16px; }\n  .registration-card {\n    width: 80%; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/src/app/registration/registration.component.scss
// module id = ../../../../../src/app/registration/registration.component.scss
// module chunks = 0